// Initialize all third-party libraries
export const initLibraries = () => {
  // Initialize Pure Counter (vanilla JS version from public/js/purecounter_vanilla.js)
  // The PureCounter class is loaded via script tag in index.html
  if (typeof window.PureCounter !== 'undefined') {
    try {
      new window.PureCounter();
    } catch (e) {
      // Silently handle initialization errors
    }
  }

  // Initialize GLightbox
  if (window.GLightbox) {
    window.GLightbox({
      selector: '.glightbox'
    });
  }

  // Initialize Isotope
  if (window.Isotope && window.imagesLoaded) {
    const isotopeLayouts = document.querySelectorAll('.isotope-layout');
    isotopeLayouts.forEach((isotopeItem) => {
      const layout = isotopeItem.getAttribute('data-layout') || 'masonry';
      const filter = isotopeItem.getAttribute('data-default-filter') || '*';
      const container = isotopeItem.querySelector('.isotope-container');
      
      if (container) {
        window.imagesLoaded(container, () => {
          const initIsotope = new window.Isotope(container, {
            itemSelector: '.isotope-item',
            layoutMode: layout,
            filter: filter,
            sortBy: 'original-order'
          });

          // Filter functionality
          const filters = isotopeItem.querySelectorAll('.isotope-filters li');
          filters.forEach((filterEl) => {
            filterEl.addEventListener('click', function() {
              isotopeItem.querySelector('.isotope-filters .filter-active')?.classList.remove('filter-active');
              this.classList.add('filter-active');
              initIsotope.arrange({
                filter: this.getAttribute('data-filter')
              });
            });
          });
        });
      }
    });
  }

  // Initialize Swiper sliders
  if (window.Swiper) {
    const swiperElements = document.querySelectorAll('.init-swiper');
    swiperElements.forEach((swiperElement) => {
      if (swiperElement.swiper) return; // Already initialized
      
      const configScript = swiperElement.querySelector('.swiper-config');
      if (configScript) {
        try {
          const config = JSON.parse(configScript.innerHTML.trim());
          new window.Swiper(swiperElement, config);
        } catch (e) {
          // Silently handle config parsing errors
        }
      }
    });
  }
};
